import LoanDrawdownStatusEnum from '~Api/Loan/LoanDrawdownStatusEnum';
import { IDictionary } from '~utilities/IDictionary';

const loanDrawdownStatusLabels: IDictionary<string> = {
    [LoanDrawdownStatusEnum.Approved]: 'Approved',
    [LoanDrawdownStatusEnum.Cancelled]: 'Cancelled',
    [LoanDrawdownStatusEnum.DisbursalInstructed]: 'Disbursal Instructed',
    [LoanDrawdownStatusEnum.PendingApproval]: 'Pending Approval',
    [LoanDrawdownStatusEnum.Processed]: 'Processed',
    [LoanDrawdownStatusEnum.QsInstructed]: 'QS Instructed',
    [LoanDrawdownStatusEnum.QsReceived]: 'QS Received',
    [LoanDrawdownStatusEnum.Requested]: 'Requested',
};

export default loanDrawdownStatusLabels;
